import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {HttpClient} from '../../../../../services/http.service';

@Component({
    selector: 'app-flat-info-planning',
    templateUrl: './flat-planning.component.html',
    styleUrls: [
        './flat-planning.component.scss'
    ],
    standalone: false
})
export class FlatPlanningComponent implements OnInit {

  @Input() public form: UntypedFormGroup;

  @Input('flat_id') public flat_id;
  @Input('floor_id') public floor_id;

  public initialized = false;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.http.post('Files.get_list_to_type', {'owner': ['realty', +this.flat_id, 3]})
      .subscribe(x => {

        const fileArr = [];
        for (const file of x) {
          fileArr.push({'id': file.file_id, 'filename': file.name, 'filepath': file.file});
        }

        this.form.addControl('planning', new UntypedFormControl(fileArr));
        this.initialized = true;
      });
  }

}
